import { ActionReducer } from '@ngrx/store';
import { BaseObject } from '../../../core/business-objects/base-object/base-object.model';
import { entityFactory } from '../../../core/helpers/entity-factory';
import { isPersistableAction, isRestfulAction } from '../../../core/store/actions/base-actions';
import { dateToString } from '../../../core/util/date-to-string';
import { isInArray } from '../../../core/util/is-in-array';
import { isBaseObject } from '../../../core/util/utils';

/**
 * This reducer ensures the audit properties are set on the object being saved
 * @param reducer
 * @returns {(state:any, action:any)=>any}
 */
export const auditPropertiesReducer = (reducer): ActionReducer<any> => {

    return (state = {}, action) => {

        try {
            // we only set/update the created/modified time if the action:
            // - is persistable
            // - is restful @todo a way to handle this is if we had separate
            //                    actions for Submit and Insert
            // - is a BaseObject
            if (
                isPersistableAction(action) &&
                isRestfulAction(action) &&
                isBaseObject(action.payload)
            ) {

                const activeUser = state.user.entities[state.user.selected];
                const activeUserId = activeUser ? activeUser.id : undefined;

                // if the object already exists in the store
                if (isInArray(action.payload.id, state[action.entity].ids)) {

                    action.payload = entityFactory(action.entity, {
                        ...(action.payload as BaseObject),
                        modified: dateToString(new Date()),
                        modifiedBy: activeUserId
                    });
                } else { // else the object does not exist in the store

                    // if the object does not already have a 'created' value
                    if (!action.payload.created) {
                        action.payload = entityFactory(action.entity, {
                            ...(action.payload as BaseObject),
                            created: dateToString(new Date()),
                            createdBy: activeUserId
                        });
                    }
                    // if the object does not already have a 'modified' value
                    if (!action.payload.modified) {
                        action.payload = entityFactory(action.entity, {
                            ...(action.payload as BaseObject),
                            modified: dateToString(new Date()),
                            modifiedBy: activeUserId
                        });
                    }
                }
            }
        } catch (e) {
            console.error('Error in auditPropertyReducer', e);
        }

        return reducer(state, action);
    };
};



// WEBPACK FOOTER //
// ./src/vas/store/middleware/audit-properties-reducer.ts